import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ShieldCheck, Loader2, RefreshCw } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";

const API = process.env.REACT_APP_BACKEND_URL;

/** Admin → Εργαλεία: κατάσταση ανωνυμοποίησης διαδίκων (πλήρης κατακερματισμός) + χειροκίνητη εκτέλεση. */
const PartyAnonCard = () => {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const load = async () => {
    try { setSt((await axios.get(`${API}/api/admin/party-anonymization/status`)).data); setErr(""); }
    catch (e) { setErr(e.response?.data?.detail || e.message || "Σφάλμα φόρτωσης κατάστασης"); }
  };
  useEffect(() => { load(); }, []);
  const running = !!st?.job?.running;
  useEffect(() => {
    if (!running) return;
    const t = setInterval(load, 2000);
    return () => clearInterval(t);
  }, [running]);
  const run = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/api/admin/party-anonymization/run`);
      toast.success(r.data.started ? "Ξεκίνησε ο κατακερματισμός στο παρασκήνιο — η πρόοδος ενημερώνεται αυτόματα" : "Ο κατακερματισμός ήδη εκτελείται");
      await load();
    } catch (e) { toast.error(e.response?.data?.detail || "Σφάλμα εκκίνησης κατακερματισμού"); }
    finally { setBusy(false); }
  };
  return (
    <Card data-testid="party-anon-card">
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-emerald-600" />Ανωνυμοποίηση Διαδίκων (GDPR)</CardTitle>
        <CardDescription>Τα ονοματεπώνυμα διαδίκων αντικαθίστανται οριστικά από ψευδώνυμα «{st?.token_format || "ΔΙΑΔ-…"}» (HMAC-SHA256) κατά την εισαγωγή/καταχώριση — για όλους τους χρήστες και τον διαχειριστή. Η διαδικασία τρέχει αυτόματα σε κάθε εκκίνηση· εδώ μπορείτε να την εκτελέσετε άμεσα.</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap items-center gap-3 text-sm">
        <span data-testid="party-anon-status">Υποθέσεις με διαδίκους: <b>{st?.cases_with_parties ?? "…"}</b> · ψευδωνυμοποιημένες: <b className="text-emerald-700">{st?.anonymized ?? "…"}</b> · εκκρεμείς: <b className={st?.pending ? "text-red-700" : ""}>{st?.pending ?? "…"}</b></span>
        <Button size="sm" variant="ghost" onClick={load} data-testid="party-anon-refresh"><RefreshCw className="w-4 h-4" /></Button>
        <Button size="sm" onClick={run} disabled={busy || running} data-testid="party-anon-run">{(busy || running) ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <ShieldCheck className="w-4 h-4 mr-1" />}{running ? `Εκτελείται… (${st?.job?.cases_updated || 0})` : "Εκτέλεση τώρα"}</Button>
        {st?.job?.finished_at && !running && <span className="text-xs text-slate-500" data-testid="party-anon-last-run">Τελευταία εκτέλεση: {new Date(st.job.finished_at).toLocaleString("el-GR")} · {st.job.cases_updated} υποθέσεις</span>}
        {st?.job?.error && <span className="text-xs text-red-700" data-testid="party-anon-job-error">Σφάλμα: {st.job.error}</span>}
        {err && <span className="text-xs text-red-700" data-testid="party-anon-error">{err}</span>}
      </CardContent>
    </Card>
  );
};

export default PartyAnonCard;
